module.exports = __webpack_public_path__ + "static/media/Eula.4c4b8bab.png";